__turbopack_context__.v({
  "active": "tableOfContents-module-scss-module___wjPpa__active",
  "dropdownItem": "tableOfContents-module-scss-module___wjPpa__dropdownItem",
  "dropdownMenu": "tableOfContents-module-scss-module___wjPpa__dropdownMenu",
  "subnavBar": "tableOfContents-module-scss-module___wjPpa__subnavBar",
  "title": "tableOfContents-module-scss-module___wjPpa__title",
  "wrapper": "tableOfContents-module-scss-module___wjPpa__wrapper",
});
